import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({ providedIn: "root" })
export class UpdateConsentWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    bookingId: string,
    consent: boolean,
    token: string
  ): Observable<void> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.UPDATE_CONSENT_ENDPOINT(bookingId))
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        consent: consent,
      })
      .build();
    return this.baseHandler.execute(parameters);
  }
}
